/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `new` - New
 * * `valid` - Valid
 * * `invalid` - Invalid
 * @export
 */
export const ValidityEnum = {
    New: 'new',
    Valid: 'valid',
    Invalid: 'invalid'
} as const;
export type ValidityEnum = typeof ValidityEnum[keyof typeof ValidityEnum];


export function instanceOfValidityEnum(value: any): boolean {
    for (const key in ValidityEnum) {
        if (Object.prototype.hasOwnProperty.call(ValidityEnum, key)) {
            if (ValidityEnum[key as keyof typeof ValidityEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ValidityEnumFromJSON(json: any): ValidityEnum {
    return ValidityEnumFromJSONTyped(json, false);
}

export function ValidityEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidityEnum {
    return json as ValidityEnum;
}

export function ValidityEnumToJSON(value?: ValidityEnum | null): any {
    return value as any;
}

export function ValidityEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ValidityEnum {
    return value as ValidityEnum;
}

